/* eslint-disable semi */
import ApiClient from './ApiClient';

const debug = process.env.NODE_ENV === 'development';

const DEFALUT_FACTORY_NAME = 'default';

/**
 * ApiClientファクトリ
 *
 * 任意の名称でファクトリを追加できます。
 * ファクトリはownerを引数にとり、ApiClientオブジェクトを返却する
 * 関数でなければなりません。
 * function(owner, options){}
 */
class ApiClientFactoryClass {
  constructor () {
    this.factories = {};
    this.factories[DEFALUT_FACTORY_NAME] = function () {
      return new ApiClient();
    };
  }
  create (name, owner, options) {
    name = name === null ? DEFALUT_FACTORY_NAME : name;
    if (!(name in this.factories)) {
      throw new Error(`${name} is invalid factory name.`);
    }
    return this.factories[name](owner, options);
  }
  registFactory (name, factory) {
    if (debug) {
      if (name in this.factories) {
        console.warn(`ApiClientFactory: ${name} is duplicated.`);
      }
    }
    this.factories[name] = factory;
  }
  registFactories (factories) {
    Object.keys(factories).forEach(name => {
      this.registFactory(name, factories[name]);
    });
  }
}
export default new ApiClientFactoryClass();



// WEBPACK FOOTER //
// ./src/core/libs/ApiClientFactory.js